import React, { useState, useEffect } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { prefix, t } from '../../../i18n'
import Moment from 'moment'
import { CaretDown, CaretUp, UnfoldMore } from '../normalizer'

const tInvoice = prefix('invoice')

const SortIcon = ({ direction, active }) => {
  if (!active) return <UnfoldMore className="data-table__sort-icon invoice__sort-icon" />
  return direction === 'asc'
    ? <CaretUp className="data-table__sort-icon data-table__sort-icon--active invoice__sort-icon invoice__sort-icon--active" />
    : <CaretDown className="data-table__sort-icon data-table__sort-icon--active invoice__sort-icon invoice__sort-icon--active" />
}

const SortableTh = ({ sortKey, label, sort, onSort, align = 'left' }) => {
  const isActive = sort.key === sortKey
  const alignClass = align === 'right' ? 'data-table__header--right' : align === 'center' ? 'data-table__header--center' : ''
  return (
    <th className={`data-table__header invoice__header ${alignClass}`} onClick={() => onSort(sortKey)}>
      <span className="data-table__header-content invoice__header-content">
        {label}
        <SortIcon direction={sort.direction} active={isActive} />
      </span>
    </th>
  )
}

const StaticTh = ({ label, align = 'left' }) => {
  const alignClass = align === 'right' ? 'data-table__header--right' : align === 'center' ? 'data-table__header--center' : ''
  return <th className={`data-table__header data-table__header--static invoice__header ${alignClass}`}>{label}</th>
}

const InvoiceTableHeader = ({ complete, validator, sort, onSort }) => {
  const registered = complete && !validator // /invoice/registered — slim column set
  const validatorComplete = complete && validator // /invoice/validated — keep legacy full set
  return (
    <thead>
      <tr className="invoice__table-header">
        {validatorComplete && <StaticTh label="Aceite" align="center" />}
        {(validator || registered) && (
          <SortableTh sortKey="user" label={tInvoice('user')} sort={sort} onSort={onSort} />
        )}
        <SortableTh sortKey="invoice_number" label={tInvoice('number')} sort={sort} onSort={onSort} />
        {(validator || registered) && (
          <SortableTh sortKey="place" label={tInvoice('place')} sort={sort} onSort={onSort} />
        )}
        <SortableTh sortKey="invoice_date" label={tInvoice('invoice-date')} sort={sort} onSort={onSort} />
        <SortableTh sortKey="created_at" label={tInvoice('registry-date')} sort={sort} onSort={onSort} />
        {validatorComplete && (
          <>
            <SortableTh sortKey="validation_date" label="Data de Verificação" sort={sort} onSort={onSort} />
            <StaticTh label="Razão" />
          </>
        )}
        {validator && <StaticTh label={tInvoice('sellType')} />}
        {validator && <StaticTh label={tInvoice('points')} align="right" />}
        <StaticTh label={registered ? '' : 'Ações'} align="center" />
      </tr>
    </thead>
  )
}

const InvoiceAcceptedIcon = ({ approved }) => (
  approved === 'approved'
    ? <i className="fas fa-check" />
    : <i className="fa fa-times" />
)

const InvoiceTableRow = ({ validator, complete, invoice, linking }) => {
  const invoicePath = `${linking}/${invoice.id}`
  const registered = complete && !validator
  const validatorComplete = complete && validator

  const ValidatorCompleteColumns = (
    <>
      <td className="invoice__cell">{invoice.validation_date}</td>
      <td className="invoice__cell break hyphens">{invoice.reprove_reason ? invoice.reprove_reason.reason : 'Sucesso'}</td>
    </>
  )

  return (
    <tr className="invoice__table-row">
      {validatorComplete && (
        <td className="invoice__cell invoice__cell--center">
          <InvoiceAcceptedIcon approved={invoice.approved} />
        </td>
      )}
      {(validator || registered) && <td className="invoice__cell">{invoice.user}</td>}
      <td className="invoice__cell">{invoice.invoice_number}</td>
      {(validator || registered) && (
        <td className="invoice__cell">{invoice.client_group ? invoice.client_group.external_identifier : 'Sem grupo'}</td>
      )}
      <td className="invoice__cell">{new Moment(invoice.invoice_date).format(t('date-format'))}</td>
      <td className="invoice__cell">{new Moment(invoice.created_at).format(t('date-format'))}</td>
      {validatorComplete && ValidatorCompleteColumns}
      {validator && <td className="invoice__cell">{invoice.sale_type}</td>}
      {validator && <td className="invoice__cell invoice__cell--right">{invoice.points || 0}</td>}
      <td className="invoice__cell invoice__cell--center">
        <Link to={invoicePath} className="invoice__action">
          <i className="fas fa-eye" />
        </Link>
      </td>
    </tr>
  )
}

const InvoiceCardCell = ({ label, children }) => (
  <div className="data-table__card-cell">
    <span className="data-table__card-label">{label}</span>
    <span className="data-table__card-value">{children}</span>
  </div>
)

const InvoiceCard = ({ validator, complete, invoice, linking }) => {
  const invoicePath = `${linking}/${invoice.id}`
  const registered = complete && !validator
  const validatorComplete = complete && validator
  return (
    <div className="data-table__card invoice__card">
      <div className="data-table__card-grid">
        {validatorComplete && (
          <InvoiceCardCell label="Aceite">
            <InvoiceAcceptedIcon approved={invoice.approved} />
          </InvoiceCardCell>
        )}
        {(validator || registered) && (
          <InvoiceCardCell label={tInvoice('user')}>{invoice.user}</InvoiceCardCell>
        )}
        <InvoiceCardCell label={tInvoice('number')}>{invoice.invoice_number}</InvoiceCardCell>
        {(validator || registered) && (
          <InvoiceCardCell label={tInvoice('place')}>
            {invoice.client_group ? invoice.client_group.external_identifier : 'Sem grupo'}
          </InvoiceCardCell>
        )}
        <InvoiceCardCell label={tInvoice('invoice-date')}>
          {new Moment(invoice.invoice_date).format(t('date-format'))}
        </InvoiceCardCell>
        <InvoiceCardCell label={tInvoice('registry-date')}>
          {new Moment(invoice.created_at).format(t('date-format'))}
        </InvoiceCardCell>
        {validatorComplete && (
          <>
            <InvoiceCardCell label="Data de Verificação">{invoice.validation_date}</InvoiceCardCell>
            <InvoiceCardCell label="Razão">
              {invoice.reprove_reason ? invoice.reprove_reason.reason : 'Sucesso'}
            </InvoiceCardCell>
          </>
        )}
        {validator && <InvoiceCardCell label={tInvoice('sellType')}>{invoice.sale_type}</InvoiceCardCell>}
        {validator && <InvoiceCardCell label={tInvoice('points')}>{invoice.points || 0}</InvoiceCardCell>}
      </div>
      <div className="data-table__card-actions">
        <Link to={invoicePath} className="data-table__card-action">
          <i className="fas fa-eye" />
          <span style={{ marginLeft: 8 }}>Ver detalhes</span>
        </Link>
      </div>
    </div>
  )
}

const InvoiceTable = ({ validator, complete, invoices, linking }) => {
  const normalize = list => list.map(inv => ({
    ...inv,
    created_at: typeof inv.created_at === 'string' ? inv.created_at.replace('Z', '') : inv.created_at,
  }))
  const [invcs, setInvcs] = useState(normalize(invoices))
  const [sort, setSort] = useState({ key: null, direction: 'asc' })

  useEffect(() => { setInvcs(normalize(invoices)) }, [invoices]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!sort.key) return
    const dateKeys = ['invoice_date', 'created_at', 'validation_date']
    const isDate = dateKeys.includes(sort.key)
    const getValue = (item) => {
      switch (sort.key) {
        case 'place': return (item.client_group && item.client_group.external_identifier) || ''
        case 'user':  return item.user || ''
        default:      return item[sort.key]
      }
    }
    setInvcs(prev => [...prev].sort((a, b) => {
      const dir = sort.direction === 'asc' ? 1 : -1
      if (isDate) {
        const aDate = new Moment(getValue(a))
        const bDate = new Moment(getValue(b))
        if (aDate.isBefore(bDate)) return -1 * dir
        if (aDate.isAfter(bDate))  return 1 * dir
        return 0
      }
      const aRaw = getValue(a)
      const bRaw = getValue(b)
      const aVal = aRaw == null ? '' : String(aRaw)
      const bVal = bRaw == null ? '' : String(bRaw)
      return aVal.localeCompare(bVal, undefined, { numeric: true }) * dir
    }))
  }, [sort])

  const handleSort = (key) => {
    setSort(prev => prev.key === key
      ? { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
      : { key, direction: 'asc' })
  }

  return (
    <>
      <table className="w-full invoice__table">
        <InvoiceTableHeader
          validator={validator}
          complete={complete}
          sort={sort}
          onSort={handleSort}
        />
        <tbody>
          {invcs.map(i => (
            <InvoiceTableRow
              key={`invoice-table-td-${i.id}`}
              validator={validator}
              linking={linking}
              invoice={i}
              complete={complete}
            />
          ))}
        </tbody>
      </table>
      <div className="invoice__cards">
        {invcs.map(i => (
          <InvoiceCard
            key={`invoice-card-${i.id}`}
            validator={validator}
            linking={linking}
            invoice={i}
            complete={complete}
          />
        ))}
      </div>
      {invcs.length <= 0 && (
        <div className="text-center text-xl text-color pl-2 py-2">
          Sem faturas
        </div>
      )}
    </>
  )
}

export default withRouter(InvoiceTable)
